import { AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import {AppService} from '../../../../app.service';
import {BonusService} from '../../bonus.service';
import {Constants} from '../../../../shared/utils/constants';
import {NgForm} from '@angular/forms';
import { PromotionProps } from '../promotion-bonus.type';
import { DialogService } from 'primeng/dynamicdialog';
import { BonusSettingDetailComponent } from '../bonus-setting-detail/bonus-setting-detail.component';

@Component({
  selector: 'fx-bonus-code-history',
  templateUrl: './bonus-code-history.component.html',
  styleUrls: ['./bonus-code-history.component.sass'],
  providers:[DialogService]

})
export class BonusCodeHistoryComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('form') form: NgForm;
  @ViewChild('table') dataTable: ElementRef<HTMLElement>;
  @ViewChildren('promoName') promoCodesName: QueryList<HTMLElement>;
  @Input()
  set loadData(val) {
    this.pageInfo.pageIndex = 1;
    const params = {
      q: '',
      page: this.pageInfo.pageIndex,
      page_size: this.pageInfo.pageSize,
    };
    this.getHistory(params);
  }
  loading = false;
  data: PromotionProps[] = [];
  condition: any = {
    q: '',
  };
  pageInfo: any = {
    pageIndex: 1,
    pageSize: 10,
    totalRecord: 0,
  };
  currency = '¥';
  selectedItem: any = {};
  expanded = false;
  codeStatus = {
    0: 'Unavailable',
    1: 'Ongoing',
    2: 'Expired',
    3: 'Unavailable'
  };
  bonusTypes = ['Normal', 'Before', 'After'];
  constructor(
    private bonusService: BonusService,
    private appService: AppService,
    private dialogService:DialogService
  ) { }

  ngOnInit(): void {
    this.searchHistory();
  }

  searchHistory(search?: boolean): void {
    this.pageInfo.pageIndex = 1;
    this.loading = search;
    const params = {
      q: (this.condition.keyword)
        ? encodeURIComponent((this.condition.keyword).trim())
        : '',
      page: this.pageInfo.pageIndex,
      page_size: this.pageInfo.pageSize,
    };

    this.getHistory(params);
  }
  getHistory(params: any): void {
    this.bonusService.getBonusCodeHistory(params)
      .subscribe(res => {
        this.loading = false;
        if (res.status === Constants.RESPONSE_STATUS.SUCCESS) {
          res.data.mt5_bonus_events.forEach(e => {
            e.bonusType =  this.bonusTypes[e.data.bonus_type];
              e.runTime =  e.data.deposit.multiple_time === 0 ? 'Single' : 'Multiple';
              e.dfw =  (e.data.deposit.distance_from_withdraw || 0) / 86400000;
              const curTime = new Date(Date.now()).getTime();
              e.status =  ((e.end_time - curTime)) > 0  ? 'On going' : 'Expired'
          })
          this.data = res.data.mt5_bonus_events;
          this.pageInfo.totalRecord = res.data.paging.total;
        }
      });
  }
  onRefresh(refresh?: boolean): void {
    this.condition.keyword = '';
    this.searchHistory(refresh);
  }
  pageChanged(page: number): void {
    this.pageInfo.pageIndex = page;
    const params = {
      q: this.condition.keyword,
      page: this.pageInfo.pageIndex,
      page_size: this.pageInfo.pageSize,
    };
    this.getHistory(params);
  }
  ngAfterViewInit(): void {
    this.promoCodesName.changes.subscribe((list) => {
      list.forEach((s: ElementRef<HTMLElement>) => {
        s.nativeElement.addEventListener('mouseenter', () => {
          this.dataTable.nativeElement.classList.add('unset-overflow');
        })
        s.nativeElement.addEventListener('mouseleave', () => {
          this.dataTable.nativeElement.classList.remove('unset-overflow');
        })
      })
    })
  }
  viewDetail(id,status){
    this.bonusService.getByCodeBonusSetting(id).subscribe({
      next:(data)=>{
          if (data.status === Constants.RESPONSE_STATUS.SUCCESS) {
            localStorage.setItem('promoProfile', JSON.stringify(data.data.bonus_event))
            const dialog = this.dialogService?.open(BonusSettingDetailComponent, {
              header: "PROMOTION CODE DETAILS",
              showHeader: true,
              width: '65%',
              data: {
                data:data.data,
                status:status,
              }
            });
            dialog?.onClose.subscribe({
              next: (isSuccess) => {
                if (isSuccess) {
                  this.searchHistory();
                }
              },
            });
          }
      }
    })


  }
  ngOnDestroy(): void {
  }

}
